
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.md?watch=parent';
    export const demoIndex = {
  ids: ["table-demo-common","table-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Table" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.md?type=demo')
};